import React from "react";
import styled from "styled-components";
import SEO from "../components/SEO";
import shoe1 from "../components/images/shoe1.png";
import shoe2 from "../components/images/shoe2.png";
//import shoe3 from "../components/images/shoe3.png";
import shoe5 from "../components/images/shoe5.png";
import shoe6 from "../components/images/shoe6.png";
import shoe7 from "../components/images/shoe7.png";
import shoe8 from "../components/images/shoe8.png";
import shoe9 from "../components/images/shoe9.png";
import sh1 from "../components/images/sh1.png";
import sh2 from "../components/images/sh2.png";
import sh3 from "../components/images/sh3.png";

const shoes = [
  { src: shoe1, name: "Nike Air Max 1", description: "Classic style with modern comfort." },
  { src: shoe2, name: "Nike Air Force 1", description: "Timeless design for everyday wear." },
  { src: shoe5, name: "Nike React Infinity Run", description: "Engineered for comfort and support." },
  { src: shoe6, name: "Nike ZoomX Vaporfly NEXT%", description: "Speed and performance for serious runners." },
  { src: shoe7, name: "Nike Air Zoom Pegasus", description: "Versatile running shoe for all distances." },
  { src: shoe8, name: "Nike Blazer Mid", description: "Retro basketball style for everyday wear." },
  { src: shoe9, name: "Nike Dunk Low", description: "Street style with a classic silhouette." },
  { src: sh1, name: "Nike Air Max 270", description: "Maximum air for all-day comfort." },
  { src: sh2, name: "Nike Air Huarache", description: "Iconic design with a snug fit." },
  { src: sh3, name: "Nike Free RN", description: "Natural feel for a more connected run." },
];

const About = () => {
  const aboutStructuredData = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    "name": "About Nike 3D Store",
    "description": "Learn about Nike's premium athletic footwear collection and our innovative 3D showcase technology. Discover our commitment to quality, innovation, and athletic excellence.",
    "url": "https://nike3d.com/about",
    "mainEntity": {
      "@type": "Organization",
      "name": "Nike 3D Store",
      "description": "Premium athletic footwear and sportswear retailer featuring innovative 3D product showcase technology",
      "foundingDate": "2024",
      "specialty": "Athletic Footwear and Sportswear"
    },
    "breadcrumb": {
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://nike3d.com/"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "About",
          "item": "https://nike3d.com/about"
        }
      ]
    }
  };

  return (
    <>
      <SEO
        title="About Nike 3D Store - Premium Athletic Footwear & Innovation | Nike 3D"
        description="Learn about Nike's premium athletic footwear collection and our innovative 3D showcase technology. Discover our commitment to quality, innovation, and athletic excellence."
        keywords="About Nike, Nike 3D store, athletic footwear innovation, Nike technology, premium sportswear, Nike history, athletic excellence, sports innovation"
        canonicalUrl="https://nike3d.com/about"
        structuredData={aboutStructuredData}
      />
      <CardsContainer>
      {shoes.map((shoe, index) => (
        <StyledWrapper key={index}>
          <div className="card">
            <div className="card-img">
              <div className="img">
                <img src={shoe.src} alt={shoe.name} />
              </div>
            </div>
            <div className="card-title">{shoe.name}</div>
            <div className="card-subtitle">{shoe.description}</div>
            <div className="card-divider" />
            <div className="card-footer">
              <div className="card-price"><span>₹</span> 8,299</div>
              <button className="card-btn">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style={{ width: '20px', height: '20px', marginBottom: '5px' }}>
                  <path d="M397.78 316h-205.13a15 15 0 0 1 -14.65-11.67l-34.54-150.48a15 15 0 0 1 14.62-18.36h274.27a15 15 0 0 1 14.65 18.36l-34.6 150.48a15 15 0 0 1 -14.62 11.67zm-193.19-30h181.25l27.67-120.48h-236.6z" />
                  <path d="m222 450a57.48 57.48 0 1 1 57.48-57.48 57.54 57.54 0 0 1 -57.48 57.48zm0-84.95a27.48 27.48 0 1 0 27.48 27.47 27.5 27.5 0 0 0 -27.48-27.47z" />
                  <path d="m368.42 450a57.48 57.48 0 1 1 57.48-57.48 57.54 57.54 0 0 1 -57.48 57.48zm0-84.95a27.48 27.48 0 1 0 27.48 27.47 27.5 27.5 0 0 0 -27.48-27.47z" />
                  <path d="m158.08 165.49a15 15 0 0 1 -14.23-10.26l-25.71-77.23h-47.44a15 15 0 1 1 0-30h58.3a15 15 0 0 1 14.23 10.26l29.13 87.49a15 15 0 0 1 -14.23 19.74z" />
                </svg>
              </button>
            </div>
          </div>
        </StyledWrapper>
      ))}
      </CardsContainer>
    </>
  );
};

// Styled Components
const CardsContainer = styled.div`
  display: flex;
  flex-wrap: wrap; /* Allow cards to wrap */
  justify-content: center; /* Center cards horizontally */
  gap: 20px; /* Space between cards */
  padding: 20px;

  @media (max-width: 768px) {
    justify-content: center; /* Center cards on smaller screens */
  }

  @media (max-width: 480px) {
    justify-content: center; /* Center cards on mobile */
  }
`;

const StyledWrapper = styled.div`
  .card {
    --font-color: #323232;
    --font-color-sub: #666;
    --bg-color: #fff;
    --main-color: #323232;
    --main-focus: #2d8cf0;
    width: 230px;
    height: 300px;
    background: var(--bg-color);
    border: 2px solid var(--main-color);
    box-shadow: 4px 4px var(--main-color);
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding: 20px;
    gap: 10px;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    margin: 10px; /* Added margin for spacing around each card */
  }

  .card-img {
    display: flex;
    justify-content: center;
  }

  .card-img .img {
    position: relative;
    width: 100px;
    height: 100px;
    border-top-left-radius: 80px 50px;
    border-top-right-radius: 80px 50px;
    background-color: transparent; /* Removed white background */
  }

  .card-img .img img {
    width: 100%; /* Ensure the image fills the container */
    height: auto; /* Maintain aspect ratio */
  }

  .card-title {
    font-size: 20px;
    font-weight: 500;
    text-align: center; /* Center align title */
    color: var(--font-color);
  }

  .card-subtitle {
    font-size: 14px;
    font-weight: 400;
    text-align: center; /* Center align subtitle */
    color: var(--font-color-sub);
  }

  .card-divider {
    height: 1px;
    background-color: var(--main-color);
  }

  .card-footer {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .card-price {
    font-size: 20px;
    font-weight: 500;
    color: var(--font-color);
  }

  .card-btn {
    height: 35px;
    background: var(--bg-color);
    border: 2px solid var(--main-color);
    border-radius: 5px;
    padding: 0 15px;
    display: flex;
    align-items: center; /* Center icon and text vertically */
    justify-content: center; /* Center icon and text horizontally */
    transition: all 0.3s;
  }

  .card-btn:hover {
    border: 2px solid var(--main-focus);
  }
`;

export default About;
